import { html } from "uhtml";

export function readerToolBar(showNavigation) {
	const className = showNavigation ? "links top active" : "links top inactive";
	return html`<nav class="controls" aria-label="Reader toolbar">
		<ul class="${className}" ?inert="${!showNavigation}">
  	<li hidden><cassis-lib></cassis-lib></li>
  	<li><cassis-contents></cassis-contents></li>
    <li class="info top">
      <cassis-title><span class="book-title" role="heading" aria-level="1"></span></cassis-title>
    </li>
    <li class="share-wrapper">
    <cassis-share></cassis-share>
    </li>
    <li class="bookmark-icon-wrapper" hidden>
    <cassis-bookmark></cassis-bookmark>
    </li>
    <li class="settings-wrapper">
    <cassis-settings></cassis-settings>
    </li>
  </ul>
</nav>`;
}
